module.exports = __webpack_public_path__ + "static/media/HCMM001.15c379cd.jpg";